interface PlaceholderType {
  [key: string]: string
}

export const createPlaceholderImage = (w: number, h: number): string => {
  return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${w} ${h}'%3E%3C/svg%3E`
}

export const SVG_PLACEHOLDER_IMAGES: PlaceholderType = {
  SQUARE: createPlaceholderImage(1000, 1000),
  CATEGORY_HERO_IMAGE: createPlaceholderImage(1768, 484),
  CATEGORY_BANNER: createPlaceholderImage(656, 190),
  TOP_NEW_ARTICLE: createPlaceholderImage(423, 192),
  TOP_CAROUSEL: createPlaceholderImage(1720, 560),
  MAGAZINE_CARD: createPlaceholderImage(500, 250),
  INDUSTRY_IMAGE: createPlaceholderImage(388, 264),
  COLOR_PATTERN_IMAGE: createPlaceholderImage(119, 68),
  EDIT_PATTERN_IMAGE: createPlaceholderImage(154, 63),
  ADDITIONAL_OPTION_IMAGE: createPlaceholderImage(180, 54),
  SIMULATOR_IMAGE: createPlaceholderImage(800, 352),
  BRAND_LOGO: createPlaceholderImage(190, 80)
}
